// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"c0b11973","496":"c60ceca1","513":"a5b1a2b0","703":"94685b76"}[chunkId] + ".chunk.js";
};